import {config} from '../config';

export default {
    getGamApiUrl: () => config.data.gam.gamApiUrl,
    getGamWssUrl: () => config.data.gam.gamWssUrl,
};
